import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const headerClass = flex({
	alignItems: "center",
	gap: "20",
	marginY: "20",
});

export const fieldWrapperClass = flex({
	alignItems: "center",
	gap: "2",
});

export const awaitingAccountNoticeClass = css({
	marginBottom: "20",
	color: "warning.100",
	fontWeight: "bold",
});
